// extracted by mini-css-extract-plugin
export default {"wrapperWithSidebar":"WrapperWithSidebar_wrapperWithSidebar__YaBxP","wrapperWithSidebar__main":"WrapperWithSidebar_wrapperWithSidebar__main__72BkD"};